import React from 'react';
import { TbLineHeight } from 'react-icons/tb';
import { t } from '@bay-email/core';
import { LineHeight } from '@extensions/AttributePanel/components/attributes/LineHeight';
import { BlockAttributeTool } from './BlockAttributeTool';

export interface LineHeightToolProps {
	getPopupContainer: () => HTMLElement;
}

export function LineHeightTool({ getPopupContainer }: LineHeightToolProps) {
	return (
		<BlockAttributeTool
			title={t('Line height')}
			icon={<TbLineHeight size={16} />}
			getPopupContainer={getPopupContainer}
		>
			<LineHeight />
		</BlockAttributeTool>
	);
}
